import { z } from 'zod';
import { AuditFieldsSchema, MoneyHufSchema, TenantIdSchema } from '../types/common.types';
import { PaginationQuerySchema } from '../types/pagination.types';

export const ContractStatusSchema = z.enum([
  'DRAFT',
  'ACTIVE',
  'COMPLETED',
  'CANCELLED',
  'EXPIRED',
]);
export type ContractStatus = z.infer<typeof ContractStatusSchema>;

export const ContractItemSchema = z.object({
  id: z.string().uuid(),
  contractId: z.string().uuid(),
  productId: z.string().uuid().nullable(),
  equipmentTypeId: z.string().uuid().nullable(),
  quantity: z.number().int().positive(),
  unitPrice: MoneyHufSchema,
  totalPrice: MoneyHufSchema,
  notes: z.string().nullable(),
});
export type ContractItem = z.infer<typeof ContractItemSchema>;

export const ContractSchema = z
  .object({
    id: z.string().uuid(),
    tenantId: TenantIdSchema,
    partnerId: z.string().uuid(),
    contractNumber: z.string(),
    status: ContractStatusSchema,
    startDate: z.string().date(),
    endDate: z.string().date(),
    totalAmount: MoneyHufSchema,
    depositAmount: MoneyHufSchema.nullable(),
    notes: z.string().nullable(),
    items: z.array(ContractItemSchema),
  })
  .merge(AuditFieldsSchema);
export type Contract = z.infer<typeof ContractSchema>;

export const ContractListQuerySchema = PaginationQuerySchema.extend({
  partnerId: z.string().uuid().optional(),
  status: ContractStatusSchema.optional(),
});
export type ContractListQuery = z.infer<typeof ContractListQuerySchema>;
